import React, { Component } from "react";
import ReactApexChart from 'react-apexcharts'
import { getFromStorage } from "../../utils/storage";
import key from "../../config/key.json";

export default class Histograms extends Component {
    constructor(props) {
      super(props);

      this.state = {
        histograms: 
        [
          {
            series: [{
              name: 'Case Uploaded',
              type: 'column',
              data: this.props.histogram1YAxisData.caseUploaded
            }, {
              name: 'Case Pending',
              type: 'line',
              data: this.props.histogram1YAxisData.casePending
            }, {
              name: 'Case Reported',
              type: 'line',
              data: this.props.histogram1YAxisData.caseReported
            }, {
              name: 'Normal',
              type: 'line',
              data: this.props.histogram1YAxisData.normal
            }, {
              name: 'Abnormal',
              type: 'line',
              data: this.props.histogram1YAxisData.abnormal
            }],
            options: {
              chart: {
                height: 350,
                type: 'line',
              },
              title: {
                text: 'Cases Count'
              },
              dataLabels: {
                enabled: true,
              },
              labels: this.props.histogram1XAxisLabels,
            }
          },
          {
            series: [ {
              name: 'Number of Cases',
              type: 'line',
              data: this.props.histogram2YAxisData.NumberOfCases
            }],
            options: {
              chart: {
                height: 350,
                type: 'line',
              },
              title: {
                text: 'Reporting Time Count'
              },
              dataLabels: {
                enabled: true,
              },
              labels: this.props.histogram2XAxisLabels,
            }
          },
          // {
          //   series: [{
          //     name: 'Number Of Cases',
          //     data: this.props.histogram2YAxisData.NumberOfCases
          //   }],
          //   options: {
          //     chart: {
          //       height: 350,
          //       type: 'bar',
          //     },
          //     title: {
          //       text: 'Reporting Time Count'
          //     },
          //     plotOptions: {
          //       bar: {
          //         horizontal: false,
          //       }
          //     },
          //     dataLabels: {
          //       enabled: true,
          //     },
          //     labels: this.props.histogram2YAxisData.ReportingTime ? this.props.histogram2YAxisData.ReportingTime : [],
          //     xaxis: {
          //       categories: this.props.histogram2YAxisData.ReportingTime ? this.props.histogram2YAxisData.ReportingTime : [],
          //     }
          //   }
          // }
          // ,
          {
            series: [{
              name: 'Case Uploaded',
              data: this.props.histogram1YAxisData.caseUploaded
            }, {
              name: 'Case Pending',
              data: this.props.histogram1YAxisData.casePending
            }, {
              name: 'Case Reported',
              data: this.props.histogram1YAxisData.caseReported
            }, {
              name: 'Normal',
              data: this.props.histogram1YAxisData.normal
            }, {
              name: 'Abnormal',
              data: this.props.histogram1YAxisData.abnormal
            }],
            options: {
              chart: {
                height: 350,
                type: 'bar',
              },
              title: {
                text: 'Cases Count'
              },
              plotOptions: {
                bar: {
                  horizontal: true,
                }
              },
              dataLabels: {
                enabled: true,
              },
              labels: this.props.histogram1XAxisLabels,
              xaxis: {
                categories: this.props.histogram1XAxisLabels
              }
            }
          },
          {
            series: [{
              name: 'Number Of Cases',
              data: this.props.histogram2YAxisData.NumberOfCases
            }],
            options: {
              chart: {
                height: 350,
                type: 'bar',
              },
              title: {
                text: 'Reporting Time Count'
              },
              plotOptions: {
                bar: {
                  horizontal: true,
                }
              },
              dataLabels: {
                enabled: true,
              },
              labels: this.props.histogram2YAxisData.ReportingTime,
              xaxis: {
                categories: this.props.histogram2YAxisData.ReportingTime,
              }
            }
          }
        ],
      };
    }
    render() {
      return (
        <div id="chart">
          {getFromStorage(key.loginInfoKey).task !== "authDiagAdminPanel" ? 
            <div>
              <div id="chart" style={{backgroundColor: "white", padding: 20}} className="shadow-4">
                <ReactApexChart options={this.state.histograms[0].options} series={this.state.histograms[0].series} type="line" height={350} />
              </div>
              <br/>
              <div id="chart" style={{backgroundColor: "white", padding: 20}} className="shadow-4">
                <ReactApexChart options={this.state.histograms[1].options} series={this.state.histograms[1].series} type="line" height={350} />
              </div>
            </div>
          :
            <div>
              <div id="chart" style={{backgroundColor: "white", padding: 20}} className="shadow-4">
                <ReactApexChart options={this.state.histograms[2].options} series={this.state.histograms[2].series} type="bar" height={350} />
              </div>
              <br/>
              <div id="chart" style={{backgroundColor: "white", padding: 20}} className="shadow-4">
                <ReactApexChart options={this.state.histograms[1].options} series={this.state.histograms[1].series} type="line" height={350} />
              </div>
            </div>
          }
          <br/>
        </div>
      );
  }
}